export const MOBILE_RAIL_LIMIT = 4;

// One coin keeps its DOM identity while travelling from the 2×2 button to the row.
export function mobileRailWidth(width: number, count: number) {
  // 52px coins, 8px gaps, and a final 52px history button.
  return Math.max(width, (count + 1) * 60 - 8);
}

export function mobileRailPose(
  width: number,
  index: number,
  open: boolean,
  count = 4,
  scroll = 0,
) {
  const content = mobileRailWidth(width, count);
  const start = (content - ((count + 1) * 60 - 8)) / 2;
  const slot = index % MOBILE_RAIL_LIMIT;
  return {
    x: open
      ? start + index * 60
      : width - 52 + 14 + (slot % 2) * 24 - 26 + scroll,
    y: open ? 0 : 64 + 14 + Math.floor(slot / 2) * 24 - 26,
    scale: open ? 1 : 20 / 52,
  };
}

export function swipeDirection(dx: number, dy: number, elapsed: number) {
  if (elapsed > 900 || Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5)
    return 0;
  return dx < 0 ? 1 : -1;
}
